import Vue from 'vue';
import * as types from './mutation-types';

const mutations = {
  [types.SET_CAT_SUBJECT_DOMAINS](state, { subjectId, catSubjectDomains }) {
    if (!state.catSubjectDomains[subjectId]) {
      Vue.set(state.catSubjectDomains, subjectId, []);
    }

    if (!state.catSubjectDomainsPosition[subjectId]) {
      Vue.set(state.catSubjectDomainsPosition, subjectId, 1);
    }

    const domainPosition = Number(state.catSubjectDomainsPosition[subjectId] + 1);
    const domainList = state.catSubjectDomains[subjectId].concat(catSubjectDomains);
    Vue.set(state.catSubjectDomainsPosition, subjectId, domainPosition);
    Vue.set(state.catSubjectDomains, subjectId, domainList);
  },

  [types.SET_CAT_STATS](state, { subjectId, catStats }) {
    Vue.set(state.catStats, subjectId, catStats);
  },

  [types.RESET_CAT_SUBJECT_DOMAINS](state) {
    Vue.set(state, 'catSubjectDomainsPosition', {});
    Vue.set(state, 'catSubjectDomains', {});
  },

};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/cat-domain/store/mutations.js